import { Button } from "@/components/ui/baseUi/button"
import { ErrorView } from "@/components/ui/layout/error/errorView"
import { Text } from "@/components/ui/baseUi/text"
import { cn } from "@/modules/lib/utils"
import { useCalendar } from "@modules/calendar/hooks/useCalendar"
import { word } from "@modules/core/utils/i18n"
import { useSidebar } from "@modules/sidebar/hooks/useSidebar"
import { TrainingProgramsTab } from "@modules/training/components/trainingProgramsTab"
import dayjs from "dayjs"
import { ChevronLeft, ChevronRight, List } from "lucide-react"
import { ErrorBoundary } from "react-error-boundary"
import { Suspense } from "react"
import { LoadingSpinner } from "@/modules/ui/components/loading"

type TrainingDateSelectorProps = {
  className?: string
} & React.ComponentProps<"div">

export function TrainingDateSelector({ className, ...props }: TrainingDateSelectorProps) {
  const { currentWeekTitle, prev, next, selectedDate, setSelectedDate } = useCalendar()
  const { sidebarNavigateTo } = useSidebar()

  const onOpenProgramListFilter = () => {
    void sidebarNavigateTo({
      content: (
        <ErrorBoundary fallback={<ErrorView />}>
          <Suspense fallback={<LoadingSpinner />}>
            <TrainingProgramsTab allowProgramSelection={true} />
          </Suspense>
        </ErrorBoundary>
      ),
      replaceAllComponents: true,
    })
  }

  return (
    <div
      className={cn("flex flex-col justify-center gap-4 rounded-4xl bg-surface-foreground p-5", className)}
      {...props}
    >
      <div className="flex flex-row items-center justify-between gap-2 text-center">
        <ChevronLeft size={24} onClick={prev} className="cursor-pointer" />
        <Text fontStyle="BS" className="font-bold">
          {currentWeekTitle}
        </Text>
        <ChevronRight size={24} onClick={next} className="cursor-pointer" />
      </div>

      <Button
        variant="outline"
        className="mx-auto text-xs capitalize"
        size="sm"
        onClick={() => setSelectedDate(dayjs())}
        disabled={dayjs().isSame(selectedDate, "day")}
      >
        {word("global.today.label")}
      </Button>

      <Button size="xs" variant="primary" className="mx-auto" onClick={onOpenProgramListFilter}>
        <List />
        {word("planning.seePrograms")}
      </Button>
    </div>
  )
}
